import { render } from "./Dialog.vue?vue&type=template&id=f0ab2976&ts=true"
import script from "./Dialog.vue?vue&type=script&lang=ts"
export * from "./Dialog.vue?vue&type=script&lang=ts"

import "./Dialog.vue?vue&type=style&index=0&id=f0ab2976&lang=css"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__